import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import AdminService from "external-services/diary-admin-service/admin.service";

const NS = 'SettingsMaintenanceCtrl';

export default function SettingsMaintenanceCtrl(
  pouchService
) {
  "ngInject";

  const vm = this;
  vm.venue = null;

  //-- define public properties
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.ERROR = 3;
  vm.state = vm.LOADING;
  //-- define public methods
  vm.deletePouchDB = deletePouchDB;

  init();

  function init() {
    vm.venue = AdminService.getVenue();

    GeneralSettingsService.get().then(settings => {
      vm.state = vm.ENTER;
      vm.settings = settings;
    });
  }

  function deletePouchDB(venueId) {
    pouchService.destroyDatabases(true, venueId);
  }
}
